import { redirect } from '@tanstack/react-router'
import { createIsomorphicFn } from '@tanstack/react-start'
import axios from 'axios'
import { getCookie as getClientCookie } from '@/utils/cookies-client'

// const baseUrl =
//   typeof window === 'undefined'
//     ? `http://0.0.0.0:${port}`
//     : window.location.origin

export const getAxiosInstance = createIsomorphicFn()
  .server(() => {
    const port = process.env.PORT || 8004

    const axiosInstance = axios.create({
      baseURL: `https://0.0.0.0:${port}/api/v1`,
      timeout: 60_000,
    })

    axiosInstance.interceptors.request.use(async config => {
      const { getCookie } = await import('@tanstack/react-start/server')

      const token = getCookie('accessToken')

      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      return config
    })

    axiosInstance.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          throw redirect({ to: '/signout' })
        }

        return Promise.reject(error)
      },
    )

    return axiosInstance
  })
  .client(() => {
    const axiosInstance = axios.create({
      baseURL: `${window.location.origin}/api/v1`,
      timeout: 60_000,
    })

    axiosInstance.interceptors.request.use(async config => {
      const token = getClientCookie('accessToken')

      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      return config
    })

    axiosInstance.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          throw redirect({ to: '/signout' })
        }

        return Promise.reject(error)
      },
    )

    return axiosInstance
  })
